export const getAdPreviewWaterfallGridLayoutStyles = (/* components, { palette = {} } = {} */) => ({
  adPreviewWaterfallGridLayoutContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },
});
